/* eslint-disable prettier/prettier */
import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import rootReducers from "./reducers";
import { composeWithDevTools } from "redux-devtools-extension";

const middleware = [thunk];

// const bindWithMiddleware = (middleware) => {
//     // if (process.env.NODE_ENV === "production") {
//         return composeWithDevTools(applyMiddleware(...middleware));
//     // }
//     // return applyMiddleware(...middleware);
// };

const store = createStore(rootReducers, composeWithDevTools(applyMiddleware(...middleware)));

export default store;